// @mui
import { AppBar, Stack, Toolbar, useTheme } from '@mui/material';

import { HEADER } from '../../config-global';
//
import { useContext } from 'react';
import Image from 'src/components/image/Image';
import { OrganizationContext } from 'src/sections/@dashboard/organization/context/OrganizationProvider';
import { Roles } from 'src/types/User';

// ----------------------------------------------------------------------

type Props = {
  onOpenNav?: VoidFunction;
  desktopHeight?: number;
};

export default function Header({ onOpenNav, desktopHeight }: Props) {
  const theme = useTheme();
  const organizationContext = useContext(OrganizationContext);
  const selectedRole = organizationContext?.selectedRole ?? null;
  const isOrganizationRole =
    selectedRole === Roles.organization_admin ||
    selectedRole === Roles.organization_owner;
  const isProfessionalRole = selectedRole === Roles.professional;

  const renderContent = (
    <>
      <Stack justifyContent="center" alignItems="center">
        <Image
          disabledEffect
          visibleByDefault
          alt="Vetsi Logo"
          src={
            isOrganizationRole || isProfessionalRole
              ? '/assets/logo/vetsi-clinic-logo.svg'
              : '/assets/logo/logo_dashboard.svg'
          }
        />
      </Stack>
    </>
  );

  return (
    <>
      <AppBar
        sx={{
          boxShadow: theme.customShadows.z8,
          height: {
            xs: HEADER.H_MOBILE,
            lg: desktopHeight || HEADER.H_MAIN_DESKTOP,
          },
          zIndex: theme.zIndex.appBar + 1,
          backgroundColor: theme.palette.background.default,
          position: 'fixed',
        }}
      >
        <Toolbar
          sx={{
            height: 1,
            minHeight: { sm: HEADER.H_MOBILE, md: HEADER.H_MOBILE, lg: 1 },
            px: { sm: 2, lg: 5 },
          }}
        >
          {renderContent}
        </Toolbar>
      </AppBar>
    </>
  );
}
